import { Abbr } from "@site/src/components";

export default function FirstPersonPlural() {
  return (
    <table
      className="table_sticky"
    >
      <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th />
          <th><Abbr>nom.</Abbr></th>
          <th><Abbr>acc.</Abbr></th>
          <th><Abbr>gen.</Abbr></th>
          <th><Abbr>dat.</Abbr></th>
          <th><Abbr>ins.</Abbr></th>
          <th><Abbr>loc.</Abbr></th>
        </tr>
        <tr>
          <th>OCS</th>
          <td> my </td>
          <td>nasъ/ny</td>
          <td>nasъ </td>
          <td>namъ/ny </td>
          <td>nami</td>
          <td>nasъ</td>
        </tr>
        <tr>
          <th>Russian</th>
          <td> my </td>
          <td>nas </td>
          <td>nas </td>
          <td>nam </td>
          <td>nami</td>
          <td>nas</td>
        </tr>
        <tr>
          <th>Belarussian</th>
          <td> my </td>
          <td>nas </td>
          <td>nas </td>
          <td>nam </td>
          <td>námi</td>
          <td>nas</td>
        </tr>
        <tr>
          <th>Ukrainian</th>
          <td> my </td>
          <td>nas </td>
          <td>nas </td>
          <td>nam </td>
          <td>námy</td>
          <td>nas</td>
        </tr>
        <tr>
          <th>Lemko-Rusyn</th>
          <td> my </td>
          <td>nas </td>
          <td>nas </td>
          <td>nam </td>
          <td>namy</td>
          <td>nas</td>
        </tr>
        <tr>
          <th>Polish</th>
          <td> my </td>
          <td>nas </td>
          <td>nas </td>
          <td>nam </td>
          <td>nami</td>
          <td>nas</td>
        </tr>
        <tr>
          <th>Cashubian</th>
          <td> më </td>
          <td>nas/nôs</td>
          <td>nas/nôs</td>
          <td>nóm </td>
          <td>nami</td>
          <td>nas/nôs</td>
        </tr>
        <tr>
          <th>Lower Sorbian</th>
          <td> my </td>
          <td>nas </td>
          <td>nas </td>
          <td>nam </td>
          <td>nami</td>
          <td>nas</td>
        </tr>
        <tr>
          <th>Upper Sorbian</th>
          <td> my </td>
          <td>nas </td>
          <td>nas </td>
          <td>nam </td>
          <td>nami</td>
          <td>nas/nami</td>
        </tr>
        <tr>
          <th>Czech</th>
          <td> my </td>
          <td>nás </td>
          <td>nás </td>
          <td>nám </td>
          <td>námi</td>
          <td>nás</td>
        </tr>
        <tr>
          <th>Slovak</th>
          <td> my </td>
          <td>nás </td>
          <td>nás </td>
          <td>nám </td>
          <td>nami</td>
          <td>nás</td>
        </tr>
        <tr>
          <th>Slovene</th>
          <td> mi </td>
          <td>nas </td>
          <td>nas </td>
          <td>nam </td>
          <td>nami</td>
          <td>nas</td>
        </tr>
        <tr>
          <th>Serbian/Croatian</th>
          <td> mî </td>
          <td>nâs/nas</td>
          <td>nâs/nas</td>
          <td>nàma/nam</td>
          <td>nàma</td>
          <td>nàma</td>
        </tr>
        <tr>
          <th>Macedonian</th>
          <td> nie </td>
          <td>nas/ne </td>
          <td>—</td>
          <td>nam/ni</td>
          <td>—</td>
          <td>—</td>
        </tr>
        <tr>
          <th>Bulgarian</th>
          <td> níe/nij</td>
          <td>nas/ni </td>
          <td>—</td>
          <td>ni/nam</td>
          <td>—</td>
          <td>—</td>
        </tr>
        <tr>
          <th>Interslavic</th>
          <td>
            <b>my</b>
          </td>
          <td>
            <b>nas</b>
          </td>
          <td>
            <b>nas</b>
          </td>
          <td>
            <b>nam</b>
          </td>
          <td>
            <b>nami</b>
          </td>
          <td>
            <b>nas</b>
          </td>
        </tr>
      </tbody>
    </table>
  )
}
